import React, { Fragment, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import FeedItem from '../Item';
import { generateUniqueId } from '../../../../utilities';

const List = (props = {}) => {
    const { messages, handleInput, ResponseProps, triggerInputFocus } = props
    const lastItemElementAfter = useRef()
    const messageLength = messages?.length
    useEffect(() => {
        const focusNeeded = lastItemElementAfter?.current && messageLength > 1
        if(focusNeeded) {
            lastItemElementAfter.current.scrollIntoView()
            triggerInputFocus && triggerInputFocus()
        }
    }, [triggerInputFocus, messageLength])

    
    if(!Array.isArray(messages) || messages.length === 0) return []

    let feed = []
    const scrollId = "spacer-for-scrolling"

    messages.forEach((message, index) => {
        const { type, hideHelp = false, hideFeedback = false, ...rest } = message
        const uniqueId = generateUniqueId(`message-list`, `#${index}`)
        const lastItem = index === messages.length - 1
        let messageProps = { 
            type,
            identifier: uniqueId, 
            ...rest 
        }
        if(type === 'response') {
            messageProps.showHelp = !hideHelp && lastItem
            messageProps.showFeedback = !hideFeedback && lastItem
            messageProps.handleInput = message.handleInput || handleInput
            messageProps.focus = lastItem && Array.isArray(message?.suggestions) && message.suggestions.length > 0
        }
        const needScrolling = lastItem && !messageProps.focus
        feed.push(<Fragment key={uniqueId + 'chat-list'}>
            <FeedItem 
                key={`osu-rc-message-${uniqueId}${type ? `-${type}` : ''}`} 
                message={messageProps} 
                ResponseProps={ResponseProps}
            />
            {needScrolling && <span aria-hidden id={scrollId + 'after'} ref={lastItemElementAfter} />}
        </Fragment>)
    })

    return feed
}

List.defaultProps = {
    messages: [],
    handleInput: (value) => console.log(`Feed List, Handle Input:`, value)
}

List.propTypes = {
    messages: PropTypes.arrayOf(PropTypes.shape({
        type: PropTypes.oneOf(['response', 'input']),
        hideHelp: PropTypes.bool,
        hideFeedback: PropTypes.bool,
        handleInput: PropTypes.func,
    })),
    handleInput: PropTypes.func
}

export default List